'use client';
import { AiOutlineUnlock } from 'react-icons/ai';

import { DATE_PRESETS, SORT_OPTIONS, ToolbarState } from './tradesQuery';

interface TradesToolbarProps {
  value: ToolbarState;
  disabled: boolean;
  onChange: (next: ToolbarState) => void;
  /** When set, the ticker is fixed (profile page): the ticker search becomes a member-name filter. */
  lockedTicker?: string;
  /** Member-name filter value (profile page only). */
  memberFilter?: string;
  onMemberFilterChange?: (value: string) => void;
}

export const TradesToolbar = ({
  disabled,
  onChange,
  value,
  lockedTicker,
  memberFilter = '',
  onMemberFilterChange,
}: TradesToolbarProps) => {
  const set = (patch: Partial<ToolbarState>) => onChange({ ...value, ...patch });
  const tickerLocked = Boolean(lockedTicker);

  return (
    <div className={`gov-toolbar ${disabled ? 'locked' : ''}`}>
      <div className="t-search">
        {tickerLocked ? (
          <input
            disabled={disabled}
            onChange={event => onMemberFilterChange?.(event.target.value)}
            placeholder="Filter by member name"
            value={memberFilter}
          />
        ) : (
          <input
            disabled={disabled}
            onChange={event => set({ ticker: event.target.value.toUpperCase() })}
            placeholder="Search by ticker — e.g. MSFT"
            value={value.ticker}
          />
        )}
        {disabled && (
          <a
            className="t-unlock"
            href="https://www.benzinga.com/premium/ideas/benzinga-edge-checkout/?t=be8be9we4gewe1be11&utm_source=government-trades"
            rel="noreferrer"
            target="_blank"
          >
            <AiOutlineUnlock size={16} /> Unlock search &amp; filters with Benzinga Edge
          </a>
        )}
      </div>
      <label className="t-filter">
        <span>Chamber</span>
        <select
          disabled={disabled}
          onChange={event => set({ chamber: event.target.value as ToolbarState['chamber'] })}
          value={value.chamber}
        >
          <option value="">All</option>
          <option value="House">House</option>
          <option value="Senate">Senate</option>
        </select>
      </label>
      <label className="t-filter">
        <span>Date</span>
        <select
          disabled={disabled}
          onChange={event => set({ datePreset: event.target.value })}
          value={value.datePreset}
        >
          {DATE_PRESETS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      <label className="t-filter">
        <span>Sort</span>
        <select disabled={disabled} onChange={event => set({ sort: event.target.value })} value={value.sort}>
          <option value="">Most Recent</option>
          {SORT_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};
